import { TreeNode } from './tree-model'

export default {
  name: 'TTreeNodeCustomContent',
  functional: true,
  props: {
    nodeRender: {
      type: Function,
      required: true
    },
    nodeModel: {
      type: Object,
      required: true,
      validator(val) {
        return val instanceof TreeNode
      }
    }
  },
  render(createElement, context) {
    return context.props.nodeRender(createElement, context.props.nodeModel.state)
  }
}



// WEBPACK FOOTER //
// ./src/module/tree/tree-node-custom-content.js